import script from "./SplitViewTypeButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplitViewTypeButton.vue?vue&type=script&setup=true&lang=ts"

import "./SplitViewTypeButton.vue?vue&type=style&index=0&id=6202180a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6202180a"]])

export default __exports__